import { SystemAction, LOG_IN, LOG_OUT } from './types'
import { User } from "_types/system";

export const logIn = (user: User): SystemAction => ({
  type: LOG_IN,
  user: user,
})

export const logOut = (): SystemAction => ({
  type: LOG_OUT,
})
